module.exports = __webpack_public_path__ + "fonts/icon-imboxlogo.41d13518235c193996486e649ba11dc0.svg";